import React from 'react';

export interface OnTourBarProps {
  stepNumber: number;
  totalSteps: number;
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
  showButton?: boolean;
  showBackButton?: boolean;
  onBackClick?: () => void;
  showLogo?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

const OnTourBar: React.FC<OnTourBarProps> = ({
  stepNumber,
  totalSteps,
  title,
  description,
  buttonText = 'Continue',
  onButtonClick,
  showButton = true,
  showBackButton = false,
  onBackClick,
  showLogo = true,
  disabled = false,
  loading = false,
}) => {
  return (
    <div className="font-sofiaSans w-full">
      {showLogo && (
        <div className="bg-white w-full border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-start">
            <img src="/logo.webp" alt="Build My Story" className="h-8 lg:h-10" />
          </div>
        </div>
      )}
      <div className="bg-[#f8f4ff] border-b border-purple-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex flex-col gap-1 flex-1 min-w-0">
            <div className="flex items-baseline gap-3">
              <span className="text-base sm:text-lg font-bold text-storyblue whitespace-nowrap">
                Step {stepNumber} of {totalSteps}
              </span>
              <h3 className="text-base sm:text-lg font-bold text-secondaryStoryBlackText leading-tight">{title}</h3>
            </div>
            <p className="text-sm text-left leading-tight mt-1">{description}</p>
            {showButton && onButtonClick && (
              <p className="text-sm text-left leading-tight mt-1">Click {buttonText} to move to the next step.</p>
            )}
          </div>
          <div className="flex items-center gap-3 shrink-0 self-end md:self-auto mt-2 md:mt-0">
            {showBackButton && onBackClick && (
              <button
                onClick={onBackClick}
                className="px-6 py-2.5 rounded-full text-sm sm:text-base font-bold bg-white border border-gray-300 text-secondaryStoryBlackText hover:bg-gray-50 transition shadow-sm"
              >
                Back
              </button>
            )}
            {showButton && onButtonClick && (
              <button
                onClick={onButtonClick}
                disabled={disabled || loading || buttonText === 'Generating...'}
                className={`px-8 py-2.5 rounded-full text-sm sm:text-base font-bold text-white transition shadow-sm ${(disabled || loading || buttonText === 'Generating...') ? 'bg-gray-400 cursor-not-allowed' : 'bg-storyblueSecondLightText hover:shadow-md'}`}
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                    Loading...
                  </span>
                ) : buttonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnTourBar;
